var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.5L13 13.5",
    stroke: "#8797AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68167 9.84987C9.19105 10.2958 8.54337 10.5286 7.88112 10.497C7.21886 10.4655 6.59627 10.1721 6.15028 9.68155C5.70429 9.19097 5.47144 8.54331 5.50295 7.88106C5.53446 7.2188 5.82774 6.59618 6.31828 6.15015",
    stroke: "#8797AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62465 4.28711C2.07657 5.57746 1 8.00001 1 8.00001C1 8.00001 3 12.4995 8 12.4995C9.1715 12.5089 10.3284 12.239 11.3748 11.7124",
    stroke: "#8797AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0381 10.5687C14.4007 9.34827 15 8.00001 15 8.00001C15 8.00001 13 3.49952 8.00004 3.49952C7.56699 3.49881 7.13463 3.53402 6.7074 3.60478",
    stroke: "#8797AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47046 5.54425C9.00182 5.64628 9.48577 5.91785 9.84972 6.31821C10.2137 6.71857 10.438 7.22615 10.4891 7.7648",
    stroke: "#8797AC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye-closed.21eb6f10a8e8ca2000a52cfdc6d2c6b8.svg";
export { ForwardRef as ReactComponent };